import PageHero from "../components/PageHero";
import Prospectus from "../components/Prospectus";

export default function ProspectusPage() {
  return (
    <div data-testid="prospectus-page">
      <PageHero label="Admissions" title="Prospectus" subtitle="View and download the official college prospectus and admission brochures." />
      <Prospectus />
    </div>
  );
}
